/*
 * Public API Surface of ngx-lib/menu
 */
export * from './menu.module';
export * from './menu.component';
